<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('nav.faqBtn')" />



    <faqContent />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import faqContent from "./../components/faqContent.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "FAQ",
  components: {
    navMenu,
    hero,
    faqContent,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
